var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0.5H30.5H33V13.4348C40.1668 15.1277 45.5 21.566 45.5 29.25C45.5 38.2246 38.2246 45.5 29.25 45.5C21.566 45.5 15.1277 40.1668 13.4348 33H0.5V30.5V3V0.5H3ZM13.0474 30.5C13.016 30.0874 13 29.6706 13 29.25C13 20.2754 20.2754 13 29.25 13C29.6706 13 30.0874 13.016 30.5 13.0474V3H3L3 30.5H13.0474ZM43 29.25C43 36.8439 36.8439 43 29.25 43C21.6561 43 15.5 36.8439 15.5 29.25C15.5 21.6561 21.6561 15.5 29.25 15.5C36.8439 15.5 43 21.6561 43 29.25Z",
    fill: "#338FCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishIcon);
export default __webpack_public_path__ + "static/media/finishIcon.9817062204eabc4ba60d386bae8cf4b4.svg";
export { ForwardRef as ReactComponent };